<template>
  <div class="wrapper">
    <dwgwmainHeader class="header"></dwgwmainHeader>
    <keep-alive>
      <components :is="showSet" class="dwgwcontent"></components>
    </keep-alive>
    <dwgwmainFooter class="footer"></dwgwmainFooter>
  </div>
</template>

<script>
import dwgwmainHeader from "@/components/dwgwmainHeader";
import dwgwmainFooter from "@/components/dwgwmainFooter";
import dwgwsy from "@/components/dwgwsy";
import dwgwabout from "@/components/dwgwabout";
import dwgwcp from "@/components/dwgwcp";
import dwgwjoin from "@/components/dwgwjoin";
import dwgwgg from "@/components/dwgwgg"
import dwgwlxwm from "@/components/dwgwlxwm"
import dwgwteam from "@/components/dwgwteam"
import { mapState } from "vuex"; 

export default {
  name: "dwgwmain",
  components: {
    dwgwmainHeader,
    dwgwmainFooter,
    dwgwsy,
    dwgwabout,
    dwgwcp,
    dwgwjoin,
    dwgwgg,
    dwgwlxwm,
    dwgwteam
  },
  computed:{
    ...mapState(["showSet"])
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.header {
  flex: 0;
  height: 100px;
  background: #7e7a7a;
  position: fixed;
  width: 100%;
  z-index: 99999;
}
.dwgwcontent {
  flex: 1;
  margin-top: 100px;
}
.footer {
  flex: 0;
  height: 100px;
  background: #7e7a7a;
}

@media (max-width: 1400px){
.wrapper{
    width: 1200px;
    margin: auto;
}
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwmain.vue